import { SkeletonType } from "Explore/Config/ImageType";
import { LoadingSimpleComponent } from "..";
import styles from "./FeatureEntities.module.scss";
import { numberRegex } from "Explore/Utils/numberRegex";
import { IconPack } from "Explore/Config/Icons";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Button } from "@mui/material";

const FeatureVenueItem = ({ data, isLoading }) => {
  const statistics = [
    { value: data?.publication_count, icon: IconPack.publications },
    { value: data?.citation_count, icon: IconPack.citation },
    { value: data?.h_index, icon: IconPack.h_index },
    { value: data?.total_authors, icon: IconPack.unit_faculty_members },
    {
      value: data?.total_institutions,
      icon: IconPack.institution_outline_black,
    },
  ].filter((e) => !!e.value);
  return (
    <div className={styles["list--item"]}>
      <LoadingSimpleComponent
        className={styles["list--item__content"]}
        isLoading={isLoading}
        type={SkeletonType.PARAGRAPH}
        rows={4}
        component={
          <>
            <p className={styles["list--item--name"]}>{data?.name}</p>
            <div className={styles["list--item--statistics"]}>
              {statistics.map((item, index) => (
                <div
                  className={styles["list--item--statistics--item"]}
                  key={index}
                >
                  {item.icon}
                  {numberRegex(item.value)}
                </div>
              ))}
            </div>
            <p className={styles["list--item--description"]}>
              RESEARCH TOPICS:
              <br />
              {(data?.keywords || [])
                .slice(0, 10)
                .map((e) => (typeof e === "string" ? e : e.value))
                .join(", ")}
            </p>
            <Button
              className={styles["list--item--btn"]}
              variant="outlined"
              href={`/explore/venue/${data?.id}`}
              endIcon={<KeyboardArrowRightIcon />}
              disabled={isLoading}
              size="small"
            >
              Explore
            </Button>
          </>
        }
      />
    </div>
  );
};

export default FeatureVenueItem;
